export function money(value: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 2
  }).format(value);
}

export function number(value: number): string {
  return new Intl.NumberFormat("zh-CN").format(value);
}

export function dateTime(value: string | null | undefined): string {
  if (!value) return "-";
  return new Intl.DateTimeFormat("zh-CN", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }).format(new Date(value));
}

export function platformLabel(platform: string): string {
  if (platform === "amazon") return "Amazon";
  if (platform === "tiktok") return "TikTok Shop";
  if (platform === "shein") return "SHEIN";
  return platform;
}

export function statusLabel(status: string): string {
  const labels: Record<string, string> = {
    pending_payment: "待付款",
    pending_shipment: "待发货",
    shipped: "已发货",
    delivered: "已送达",
    cancelled: "已取消",
    refunded: "已退款",
    success: "成功",
    partial: "部分异常",
    failed: "失败",
    skipped: "已跳过",
    running: "执行中",
    connected: "已连接",
    needs_auth: "需授权",
    needs_credentials: "未配置",
    active: "启用",
    disabled: "停用",
    error: "异常"
  };
  return labels[status] ?? status;
}
